import React, { Suspense, useEffect } from 'react';
import MetaHeader from '../MetaHeader/MetaHeader';
import Header from '../HeaderTop/HeaderTop';
import toast, { Toaster } from 'react-hot-toast';

import { useDispatch, useSelector } from 'react-redux';
import style from './Layout.module.css';
import Footer from '../HomeComponents/Footer/Footer';
import {
  useAudioVideo,
  useMeetingManager,
  useMeetingStatus,
} from 'amazon-chime-sdk-component-library-react';
import { selectSignIn } from '../../redux/auth/selectors';
import { getOnlineSession } from '../../api/usersApi';
import { setOnlineUsersList } from '../../redux/websocket/slice';

export default function Layout({ children }) {
  const audioVideo = useAudioVideo();
  const isSignedIn = useSelector(selectSignIn);
  const meetingManager = useMeetingManager();
  const meetingStatus = useMeetingStatus();
  const connected = meetingStatus === 1;
  const dispatch = useDispatch();

  useEffect(() => {
    getOnlineSession().then(array => {
      dispatch(setOnlineUsersList(array));
    });
  }, [dispatch]);

  useEffect(() => {
    if (!isSignedIn && connected) {
      try {
        meetingManager.leave();
      } catch (err) {
        console.error(err);
      }
    }
  }, [isSignedIn, connected]);

  useEffect(() => {
    if (audioVideo) {
      console.log(audioVideo);

      audioVideo.addObserver({
        audioVideoDidStop: sessionStatus => {
          console.log('Сесія завершена:', sessionStatus.statusCode());
          if (sessionStatus.statusCode() === 11) {
            toast.error('We are sorry. Lady is a bit busy at this moment.');
          }
        },
      });
    }
  }, [audioVideo]);

  return (
    <div suppressHydrationWarning={true} className={style.layoutContainer}>
      <MetaHeader></MetaHeader>
      <Header></Header>
      <main className={style.mainContent}>
        <Suspense fallback={<div style={{ minHeight: '100vh' }}></div>}>
          {children}
        </Suspense>
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}
